/** Validation */
export enum EValidationMessageType {
  Info,
  Warning,
  Error,
  Critical
}

/** A representation of the status types */
export enum EMessageStatus {
  None = '',
  Success = 'success',
  Error = 'error',
  Warning = 'warning',
  Information = 'information',
  Critical = 'critical',
  Alert = 'alert'
}

export interface IMessageModel {
  status: number;
  statusLevel: EMessageStatus;
  statusText: string;
}

export interface IStatusUpdate {
  status: EMessageStatus;
  message: string;
  persist?: boolean;
}

export interface IMessage {
  severity: EMessageStatus;
  summary?: string;
  detail?: string;
  id?: number;
  key?: string;
  life?: number;
  sticky?: boolean;
  closable?: boolean;
  data?: string;
}

export interface ICloseMessage {
  index: number;
  message: IMessage;
}
